module.exports = {
      id: "book-icon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite.svg#book-icon",
      toString: function () {
        return this.url;
      }
    }